import React, { Component } from 'react';
import { omit } from 'lodash';
import classNames from 'classnames';
import Label from './Label.js';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { i as infoIconStyles } from '../InfoIcon-f1b0281a.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';

var css_248z = ".xiQ0E{display:block;font-size:14px}[dir] .xiQ0E{margin-bottom:9px}.zpGz0{display:block;font-size:14px}[dir] .zpGz0{margin:9px}._8eUPX{box-sizing:border-box;color:var(--ricos-settings-text-color,#333);font-size:14px;font-weight:300;height:42px;line-height:1.5;width:100%}[dir] ._8eUPX{border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6));border-radius:var(--ricos-settings-inputs-border-radius,0);box-shadow:none;padding:0 17px}._8eUPX::placeholder{color:var(--ricos-settings-inputs-placeholder-color,rgba(0,0,0,.4))}.Qn1zY{height:101px;resize:none}[dir] .Qn1zY{padding:9px 17px}.QQjge{height:100%}.JLDcR{bottom:5px;position:relative}[dir=ltr] .JLDcR{margin-left:4px}[dir=rtl] .JLDcR{margin-right:4px}.JLDcR:hover{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}";
var styles = {"inputWithLabel_label":"xiQ0E","inputWithLabel_capacity":"zpGz0","inputWithLabel_input":"_8eUPX","inputWithLabel_textArea":"Qn1zY","inputWithLabel_fullHeight":"QQjge","infoIcon":"JLDcR"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class InputWithLabel extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = (e) => {
      const { onChange, getTarget } = this.props;
      onChange(getTarget ? e.target : e.target.value);
    };
    this.renderInput = () => {
      const { styles: styles2 } = this;
      const _a = this.props, {
        id,
        isTextArea,
        isFullHeight,
        dataHook,
        isMobile,
        tooltipTextKey,
        t,
        inputRef,
        placeholder,
        onBlur
      } = _a, otherProps = __objRest(_a, [
        "id",
        "isTextArea",
        "isFullHeight",
        "dataHook",
        "isMobile",
        "tooltipTextKey",
        "t",
        "inputRef",
        "placeholder",
        "onBlur"
      ]);
      const inputProps = omit(otherProps, ["theme", "onChange"]);
      const inputClassName = classNames(styles2.inputWithLabel_input, {
        [styles2.inputWithLabel_textArea]: isTextArea,
        [styles2.inputWithLabel_fullHeight]: isFullHeight
      });
      const InputComponent = isTextArea ? "textarea" : "input";
      return /* @__PURE__ */ React.createElement(
        InputComponent,
        __spreadValues({
          className: inputClassName,
          id,
          "data-hook": dataHook,
          onChange: this.handleOnChange,
          onBlur,
          placeholder,
          ref: inputRef,
          onKeyDown: (e) => {
            if (isTextArea && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
              e.stopPropagation();
            }
          }
        }, inputProps)
      );
    };
    this.renderCharacterCapacity = () => {
      const { styles: styles2 } = this;
      const { value, maxLength } = this.props;
      return /* @__PURE__ */ React.createElement("span", { className: styles2.inputWithLabel_capacity }, value.length + "/" + maxLength);
    };
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { styles: styles2 } = this;
    const { id, label, maxLength, tooltipTextKey, t, isMobile } = this.props;
    if (label) {
      return /* @__PURE__ */ React.createElement("label", { htmlFor: id }, /* @__PURE__ */ React.createElement("div", { className: infoIconStyles.infoContainer }, /* @__PURE__ */ React.createElement("span", { className: styles2.inputWithLabel_label }, /* @__PURE__ */ React.createElement(
        Label,
        {
          label,
          tooltipText: tooltipTextKey && (t == null ? void 0 : t(tooltipTextKey)),
          isMobile
        }
      ))), this.renderInput(), maxLength && this.renderCharacterCapacity());
    } else {
      return this.renderInput();
    }
  }
}
InputWithLabel.defaultProps = {
  value: "",
  isMobile: false
};

export { InputWithLabel as default };
//# sourceMappingURL=InputWithLabel.js.map
